export default {
  type: "Feature",
  properties: {
    name: "Хатгал",
    location: [50.04213681169701, 100.3601212184507],
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[50.440283718646576, 100.16432747823451]]],
  },
};
